import { render, staticRenderFns } from "./AlertsTotalTrendWidget.vue?vue&type=template&id=677956b0&"
import script from "./AlertsTotalTrendWidget.vue?vue&type=script&lang=js&"
export * from "./AlertsTotalTrendWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports